import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface AppLayoutProps {
  children: React.ReactNode;
  currentPage: string;
  onNavigate: (page: string) => void;
  title: string;
}
export function AppLayout({
  children,
  currentPage,
  onNavigate,
  title
}: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-gray-50" data-id="element-19">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)} currentPage={currentPage} onNavigate={onNavigate} data-id="element-20" />

      <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} title={title} data-id="element-21" />

      <main className="lg:pl-64 pt-16 min-h-screen transition-all duration-300" data-id="element-22">
        <div className="p-4 lg:p-8 max-w-7xl mx-auto" data-id="element-23">{children}</div>
      </main>
    </div>;
}